"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeEmojis = void 0;
const decodeEmojis = (text) => {
    const emojiRegex = /\[\[emoji ((?:%[0-9a-fA-F]{2})*)\]\]/g;
    return text.replace(emojiRegex, (_, captureGroup) => decodeURIComponent(captureGroup));
};
exports.decodeEmojis = decodeEmojis;
